import { CarsState } from '../../types';

export const resetLocationSharing = (state: CarsState) => {
  state.locationSharing.addingStatus = undefined;
  state.locationSharing.data = undefined;
  state.locationSharing.deletingStatus = undefined;
  state.locationSharing.lastAddedId = undefined;
  state.locationSharing.loadingStatus = undefined;
  state.locationSharing.selectedAutoNumber = undefined;
};
